import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";

export function tags(channel) {
  const genre = channel?.genres?.[0]?.name || "";

  return {
    title: `${channel.name}【${genre}】の注目の番組 動画配信 | スカパー！動画ストア`,
    keywords: `注目の番組,${channel.name},スカパー！動画ストア,動画配信,スカパー！`,
    description: `${channel.name}の注目の番組をピックアップ！スカパー！動画ストアではサッカー・プロレス・格闘技などの動画を配信中！`,
    og: {
      type: "article",
      url: `${config.host.vod}${routes.channelDetailFeatured(channel.id)}`,
    },
  };
}

export default function ChannelFeaturedMetaTags({ channel }) {
  const props = tags(channel);

  return <MetaTags {...props} />;
}
